import { useContextSelector } from 'use-context-selector';
import { GlobalSiteSettingsContextType } from '@/Context/GlobalSiteSettings/useActions';
import { GlobalSiteSettingsContext } from '@/Context/GlobalSiteSettings';

export function useGlobalSiteSettingsContext<Selected>(fn: (val: GlobalSiteSettingsContextType) => Selected): Selected {
  return useContextSelector(GlobalSiteSettingsContext, state => fn(state));
}
